export const ENVIDE = {
  sndnv: {
    scope: "Sanmina",
    stage: "DEV",
  },
  snunv: {
    scope: "Sanmina",
    stage: "UAT",
  },
  snpnv: {
    scope: "Sanmina",
    stage: "PROD",
  },
  sndnvi: {
    scope: "Sanmina",
    stage: "DEV",
    MES: "MES16",
  },
  sndnvq: {
    scope: "Sanmina",
    stage: "SQA",
    MES: "MES16",
  },
  sndnvv: {
    scope: "Sanmina",
    stage: "PREVIEW",
    MES: "MES16",
  },
  cndnv: {
    scope: "42Q",
    stage: "DEV",
  },
  cnunv: {
    scope: "42Q",
    stage: "UAT",
  },
  cnpnv: {
    scope: "42Q",
    stage: "PROD",
  },
  bndnv: {
    scope: "BloomEnergy",
    stage: "DEV",
  },
  bnunv: {
    scope: "BloomEnergy",
    stage: "UAT",
  },
  bnpnv: {
    scope: "BloomEnergy",
    stage: "PROD",
  },
  cmpnv1574: {
    scope: "42Q-Medical",
    stage: "PROD",
  },
  cmunv1574: {
    scope: "42Q-Medical",
    stage: "UAT",
  },
  demo: {
    scope: "Demo",
    stage: "PROD",
  },
};
export const SCOPE_LIST = [
  "Sanmina",
  "42Q",
  "42Q-Medical",
  "BloomEnergy",
  "Demo",
];
export const STAGE_LIST = ["DEV", "SQA", "UAT", "PROD", "PREVIEW"];
export const AVAIL_SCOPES = [
  "42QAPI/Sanmina",
  "42QAPI/42Q",
  "42QAPI/BloomEnergy",
  "42QAPI/42Q-Medical",
  "42QAPI/Demo",
];
export const MES_LIST = ["MES15", "MES16"];
export const configOptions = {
  hostFilter: [
    { key: "Host", text: "Host", value: "Host" },
    { key: "Name", text: "Alias", value: "Name" },
  ],
  appHostFilter: [
    { key: "Host", text: "Host", value: "Host" },
    { key: "Scope", text: "Scope", value: "Scope" },
  ],
  profileFilter: [
    {
      key: "ProfileName",
      text: "Profile Name",
      value: "ProfileName",
    },
    {
      key: "Description",
      text: "Description",
      value: "Description",
    },
    {
      key: "ProfileId",
      text: "Profile Id",
      value: "ProfileId",
    }
  ],

  actionFilter: [
    {key: "Add App", text: "Add App", value: "Add App"},
    {key: "Add Host", text: "Add Host", value: "Add Host"},
    {key: "Add Profile", text: "Add Profile", value: "Add Profile"},
    {key: "Add MES16 App Host", text: "Add MES16 App Host", value: "Add MES16 App Host"},
    {key: "Delete App", text: "Delete App", value: "Delete App"},
    {key: "Delete Host", text: "Delete Host", value: "Delete Host"},
    {key: "Delete Profile ", text: "Delete Profile", value: "Delete Profile"},
    {key: "Delete User", text: "Delete User", value: "Delete User"},
    {key: "Delete MES16 App Host", text: "Delete MES16 App Host", value: "Delete MES16 App Host"},
    {key: "Update App", text: "Update App", value: "Update App"},
    {key: "Update Host", text: "Update Host", value: "Update Host"},
    {key: "Update Profile", text: "Update Profile", value: "Update Profile"},
    {key: "Update MES15 Target", text: "Update MES15 Target", value: "Update MES15 Target"},
    {key: "Update MES16 App Host", text: "Update MES16 App Host", value: "Update MES16 App Host"},
    {key: "Update MES15 App Profile", text: "Update MES15 App Profile", value: "Update MES15 App Profile"},
  ],
  scope: [
    { key: "Sanmina", text: "Sanmina", value: "Sanmina" },
    { key: "42Q", text: "42Q", value: "42Q" },
    { key: "42Q-Medical", text: "42Q-Medical", value: "42Q-Medical" },
    { key: "BloomEnergy", text: "BloomEnergy", value: "BloomEnergy" },
    { key: "Demo", text: "Demo", value: "Demo" },
  ],
  stage: [
    { key: "DEV", text: "DEV", value: "DEV" },
    { key: "SQA", text: "SQA", value: "SQA" },
    { key: "UAT", text: "UAT", value: "UAT" },
    { key: "PROD", text: "PROD", value: "PROD" },
    { key: "PREVIEW", text: "PREVIEW", value: "PREVIEW" },
  ],
  MES: [
    { key: "MES15", text: "MES15", value: "MES15" },
    { key: "MES16", text: "MES16", value: "MES16" },
  ],
};

export const HOST_COLUMN_LIST = [
  { label: "Envide", key: "Envide" },
  { label: "Scope", key: "Scope" },
  { label: "Stage", key: "Stage" },
  { label: "Target", key: "Target" },
  { label: "Profile Name", key: "ProfileName" },
  { label: "Version", key: "Version" },
];
export const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("default", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
});
export const PAGE_SIZE = 10;
export const REQUEST_LIMIT = 5;
export const TIMEOUT_DURATION = 10000;